import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface LocationState {
  suppressScrollBehavior?: boolean;
}

export function ScrollToTopManager() {
  const location = useLocation<null | LocationState>();
  const url = `${location.pathname}${location.search}`;
  const canScroll = !location.state?.suppressScrollBehavior;

  useEffect(() => {
    if (canScroll) {
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }, [url, canScroll]);

  return null;
}
